import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Flex, MyModal, PDFViewer, StyledText } from 'src/components';
import { StyledTextVariantsTypeV2 } from '../../../components/StyledText';

import UserApiCalls from 'src/pods/user/api/ApiCalls';
import { getPractitioner } from 'src/pods/user/state/actions';
import { toggleErrorModal } from 'src/pods/system/state/actions';
import { parseError } from '../../../utils/helpers';
import { translate } from 'src/translations/translations';
import { RootState } from 'src/store';

const AcceptPractitionerTosModal = (): ReactElement => {
    const dispatch = useDispatch();
    const practitioner = useSelector((state: RootState) => state.practitionerReducer.practitioner);

    const [tosData, setTosData] = useState<Uint8Array | null>(null);

    const acceptTos = async () => {
        try {
            await UserApiCalls.acceptLastCreatedPractitionerToS();
            dispatch(getPractitioner());
        } catch (err) {
            const errorMessage = parseError(err, 'Error occurred while accepting ToS.');
            dispatch(toggleErrorModal(translate('errors.GENERAL_ERROR_TITLE'), errorMessage));
        }
    };

    const getToS = async () => {
        try {
            const response = await UserApiCalls.getLastPractitionerToS();
            const tosURL = response?.data?.tosURI;

            fetch(tosURL, {
                method: 'GET',
            })
                .then((response: any) => response.arrayBuffer())
                .then((arrayBuffer: any) => {
                    const buffer = new Uint8Array(arrayBuffer);
                    setTosData(buffer);
                });
        } catch (err) {
            const errorMessage = parseError(err, 'Error occurred while getting ToS file.');
            dispatch(toggleErrorModal(translate('errors.GENERAL_ERROR_TITLE'), errorMessage));
        }
    };

    useEffect(() => {
        getToS();
        //eslint-disable-next-line
    }, []);

    return (
        <MyModal
            size="medium"
            padding={'0px'}
            border={'none'}
            visible={practitioner && !practitioner?.tosAccepted}
            width={'50vw'}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
            closeModal={undefined}
        >
            <Flex flexDirection="column" alignItems="center" height="100%">
                <Flex flexDirection="column" alignItems="center" justifyContent="center" width={'100%'}>
                    <PDFViewer data={tosData} inModal={true} />
                </Flex>
                <StyledText
                    width={'100%'}
                    onClick={acceptTos}
                    text={translate('common.acceptToS')}
                    variant={StyledTextVariantsTypeV2.LINK_1}
                    margin={'20px 0'}
                    textAlign={'center'}
                />
            </Flex>
        </MyModal>
    );
};

export default AcceptPractitionerTosModal;
